import React from "react";

const LazyRun = React.lazy(() => import("./Run").then((m) => ({ default: m.Run })));

export default LazyRun;
